import React from 'react';

const TextDateTime = (props) => {
	//use https://react.rocks/example/input-moment
	return (
		<input
			id={props.id}
			className={`cp-text-datetime form-control ${props.className}`}
			value={props.value}
			onChange={props.onChange}
			placeholder={props.placeholder}
			type="text"
		/>
	);
};

export default TextDateTime;


// WEBPACK FOOTER //
// ./src/views/components/generic/text_datetime/TextDateTime.jsx